<mat-form-field 
  [appearance]="appearance" 
  [class.float-start]="position === 'left'" 
  [class.float-end]="position === 'right'" 
  class="custom-search-field" [style.width.%]="width">
  
  <mat-label>Recherche</mat-label>
  <input matInput (keyup)="getValue($event)" placeholder="Entrez votre recherche" #input>
  <mat-icon matPrefix class="search-icon">search</mat-icon>
  
  @if (input.value !== '') {
    <button mat-button matSuffix color="accent" (click)="resetValue(input)" aria-label="Effacer la recherche">
      <mat-icon>close</mat-icon>
    </button>
  }
</mat-form-field>

